import SettingsTabs from "./settings-tabs.container";

export default SettingsTabs;
